import { api } from "@/lib/api";
import { useAuthStore } from "./store";

export function useLogout() {
  return async () => {
    try {
      await api("/auth/logout/", { method: "POST", skipRefresh: true });
    } catch {
      // ignore
    }
    // IR-1241: an explicit Sign-out is a "manual" logout, so the login banner
    // stays silent (no "session expired" message on a deliberate logout).
    useAuthStore.getState().logout("manual");
  };
}
